export {default, ArrowLinkProps} from './ArrowLink';
